<template>
    <v-dialog v-model="dialog" persistent max-width="900px">
        <v-card>
            <v-card-title style="margin-bottom: 17px;">
                Dispatch Reports
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="3">
                        <v-select
                            :items="dispatchReports.ReportList"
                            label="Select a report"
                            outlined
                            item-text="name"
                            item-value="value"
                            v-model="dispatchReports.SelectedReport"
                            dense
                            hide-details
                            return-object
                        ></v-select>
                    </v-col>
                    <v-col cols="3">
                        <v-combobox
                            v-model="dispatchReports.Params.Customer"
                            :items="customers"
                            item-text="Name"
                            item-value="id"
                            label="Select a customer"
                            dense
                            hide-details
                        ></v-combobox>
                    </v-col>
                    <v-col cols="3">
                        <v-text-field
                            label="Start Date"
                            v-model="dispatchReports.Params.StartDate"
                            class="mr-2"
                            placeholder="YYYY-MM-DD"
                            v-mask="'####-##-##'"
                            dense
                            hide-details
                        ></v-text-field>
                    </v-col>
                    <v-col cols="3">
                        <v-text-field
                            label="End Date"
                            v-model="dispatchReports.Params.EndDate"
                            class="ml-2"
                            placeholder="YYYY-MM-DD"
                            v-mask="'####-##-##'"
                            dense
                            hide-details
                        ></v-text-field>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-btn text @click="getDispatchReportBySelect">
                    Get Report
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn text @click="dialog = false">
                    Close
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from 'axios';
import { mask } from 'vue-the-mask';
export default {
    name: 'DispatchReports',
    props: ['value', 'customers'],
    directives: { mask },
    data() {
        return {
            dispatchReports: {
                Show: false,
                ReportList: [
                    {
                        name: 'Load Tracking',
                        value: 'load-tracking',
                        endpoint: '/order/load-tracking',
                        export: true
                    }
                ],
                Params: {
                    StartDate: '',
                    EndDate: '',
                    Customer: null
                },
                SelectedReport: {}
            }
        };
    },
    computed: {
        dialog: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        }
    },
    methods: {
        getDispatchReportBySelect() {
            console.log('getDispatchReportBySelect', this.dispatchReports);
            let str = this.$store;

            // Validate dates
            if (
                this.dispatchReports.Params.StartDate === '' ||
                this.dispatchReports.Params.EndDate === ''
            ) {
                str.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'You must select a date range.'
                });
                return;
            }

            let params = {
                StartDate: this.dispatchReports.Params.StartDate,
                EndDate: this.dispatchReports.Params.EndDate,
                Export: this.dispatchReports.SelectedReport.export,
                Customer:
                    this.dispatchReports.Params.Customer !== null
                        ? this.dispatchReports.Params.Customer.id
                        : null
            };
            console.log(params);
            this.$store.state.isLoading = true;
            axios
                .post(this.dispatchReports.SelectedReport.endpoint, params, {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const fileName =
                        this.dispatchReports.SelectedReport.name + '.xlsx';
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                    str.state.isLoading = false;
                    this.dispatchReports.Show = false;
                })
                .catch(function(error) {
                    console.log(error);
                    str.state.isLoading = false;
                    str.dispatch('setSnackbar', {
                        color: 'error',
                        text:
                            'Something is wrong. Please contact the administrator.'
                    });
                });
        }
    }
};
</script>
